﻿﻿export interface ITicketRequest {
    id: number;
    fromEmail: string;
    contactId: number;
    firstName: string;
    lastName: string;
    email: string;
    phoneNumber: string;
    cc: string[];
    subject: string;
    description: string;
    groupId: number;
    assignedUserId: number;
    entityType: number;
    entityTypeId: number;
    ticketStatusId: number;
    ticketTypeId: number;
    tierLevelId: number;
    urgency: number;
    isEmail: boolean;
    tags: string[];
    files: File[];
}
